module.exports = __webpack_public_path__ + "media/flags/sr-a2d5152d.svg";